// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"132":"559f2ec2","212":"87e67cc8","215":"e28da55f","332":"4ea59b9c","533":"d7ba2188","610":"1e50621f","758":"a4bcbe79"}[chunkId] + ".chunk.js";
};